<template>
  <div class="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg">
    <div class="flex-auto px-2 py-1">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1 content-center">
          <h5 class="text-blueGray-400 uppercase font-bold text-xs">
            {{ statSubtitle }}
          </h5>
          <span class="font-semibold text-xl text-blueGray-700">
            {{ statTitle }}
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div v-if="statIconName"
            class="text-white p-1 text-center inline-flex items-center justify-center w-5 h-5 shadow-lg rounded-full m-3"
            :class="[statIconColor]">
            <i :class="[statIconName]"></i>
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-400 mt-4" v-if="statPercent">
        <span class="mr-2" :class="[statPercentColor]">
          <i :class="[
            statArrow ? `fas fa-arrow-${statArrow}` : '',
          ]"></i>
          {{ statPercent }}
          <template v-if="statPercent">
            %
          </template>
        </span>
        <span class="whitespace-nowrap">{{ statDescripiron }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "card-stats",
  props: {
    statSubtitle: {
      type: String,
    },
    statTitle: {
      type: String,
    },
    statArrow: {
      type: String,
    },
    statPercent: {
      type: String,
    },
    // can be any of the text color utilities
    // from tailwindcss
    statPercentColor: {
      type: String,
      default: "text-emerald-500",
    },
    statDescripiron: {
      type: String,
    },
    statIconName: {
      type: String,
    },
    // can be any of the background color utilities
    // from tailwindcss
    statIconColor: {
      type: String,
      default: "bg-red-500",
    },
  },
};
</script>
